
import { MessageSquare } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';

export const EmptyChatHistory = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="h-12 w-12 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        <MessageSquare className="h-6 w-6 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">No chat history yet</h3>
      <p className="text-sm text-gray-500 mb-4 max-w-sm">
        Start a conversation with Stewie to get insights about trading, market analysis, or compliance.
      </p>
      <Button 
        onClick={() => navigate('/dashboard')}
        className="bg-[#221F26] hover:bg-[#403E43] text-white"
      >
        Start a Conversation
      </Button>
    </div>
  );
};
